<app-loading *ngIf="isLoading$ | async" title="step groups"></app-loading>
<div class="devices-card-wrapper" *ngIf="!(isLoading$ | async) ">
    <app-device-card *ngFor="let device of devices"
                     [device]="device"
                     [isSelected]="isSelected(device)"
                     (deviceClick)="onDeviceClick($event)">
    </app-device-card>
</div>
<!-- Display no devices message when there are no devices and loading is done -->
<app-no-compatible-devices *ngIf="devices.length === 0 && !(isLoading$ | async)"></app-no-compatible-devices>